import { useMemo } from "react";

import * as Converter from "./converter";
import * as Constants from "../../_constants";

import type * as Type from "./type";
import type * as Repository from "../../_repository";

type Props = {
	/**
	 * 施設が持つオプション一覧
	 */
	optionPmsOptionListQueryData: Repository.Query.QueryData.OptionPmsOptionListQueryData;
	/**
	 * 表示するオプション
	 */
	displayOptionIdList: string[];
};
type Result = {
	viewData: Type.ViewData;
};

export const useViewData = ({ optionPmsOptionListQueryData, displayOptionIdList }: Props): Result => {
	const { onConvertViewData } = Converter.useViewDataConverter();

	/**
	 * QueryData へ変換
	 */
	const viewData = useMemo(
		() => onConvertViewData({ queryData: optionPmsOptionListQueryData }),
		[onConvertViewData, optionPmsOptionListQueryData],
	);

	/**
	 * 表示するオプションのみに絞り込む（checked の更新）
	 */
	const filteredViewData = useMemo(() => {
		/**
		 * 表示するオプションがない場合は、全てのオプションを非表示する
		 */
		if (displayOptionIdList.length === 0) {
			return {
				...viewData,
				options: viewData.options.map((option) => {
					return {
						...option,
						checked: false,
					};
				}),
				displayAll: false,
			};
		}

		const hasOnlyDisplayAll = displayOptionIdList.every((id) => id === Constants.FilterValue.displayAll);
		/**
		 * 全てを表示フラグがあれば、全てのオプションを表示する
		 */
		if (hasOnlyDisplayAll) {
			return {
				...viewData,
				options: viewData.options.map((option) => {
					return {
						...option,
						checked: false,
					};
				}),
				displayAll: true,
			};
		}

		/**
		 * 任意のオプションのみを表示する
		 */
		return {
			...viewData,
			options: viewData.options.map((option) => {
				return {
					...option,
					checked: displayOptionIdList.includes(option.id),
				};
			}),
			displayAll: false,
		};
	}, [displayOptionIdList, viewData]);

	return {
		viewData: filteredViewData,
	};
};
